import dayjs, { Dayjs } from 'dayjs'
import { StateCreator } from 'zustand/vanilla'
import { PurchaseOrderSlice } from '../purchase-orders/slice'
import { SharedSlice } from 'src/components/slice'
import { parseSortModelToParamString } from '$components/common'

interface PurchaseOrderHistoryState {
  purchaseOrderHistoryFilters: {
    from: Dayjs
    to: Dayjs
    referenceNumber: string
    supplierId: string
  }
}

export interface PurchaseOrderHistorySlice extends PurchaseOrderHistoryState {
  resetPurchaseOrderHistorySlice: () => void

  setPurchaseOrderHistoryFilters: (
    filters: PurchaseOrderHistoryState['purchaseOrderHistoryFilters']
  ) => void
}

export const initialState: PurchaseOrderHistoryState = {
  purchaseOrderHistoryFilters: {
    from: dayjs().subtract(1, 'month').startOf('day'),
    to: dayjs(),
    referenceNumber: '',
    supplierId: '',
  },
}

const createPurchaseOrderHistorySlice: StateCreator<
  PurchaseOrderHistorySlice & PurchaseOrderSlice & SharedSlice,
  [],
  [],
  PurchaseOrderHistorySlice
> = (set, get) => ({
  ...initialState,

  resetPurchaseOrderHistorySlice: () => set(initialState),

  setPurchaseOrderHistoryFilters: async (
    filters: PurchaseOrderHistoryState['purchaseOrderHistoryFilters']
  ): Promise<void> => {
    set(() => ({
      purchaseOrderHistoryFilters: filters,
    }))

    await get().getPurchaseOrdersPaginated({
      start: filters.from,
      end: filters.to,
      referenceNumber: filters.referenceNumber,
      supplierName: filters.supplierId,
      page: get().purchaseOrderPaginationModel.page,
      pageSize: get().purchaseOrderPaginationModel.pageSize,
      sort: parseSortModelToParamString(get().purchaseOrderSortModel),
    })
  },
})

export default createPurchaseOrderHistorySlice
